import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const DependentBlockStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 3rem;
  padding: 2rem;
  border: 0.1rem solid ${colors.neutral[300]};
  border-radius: 6px;
  background-color: ${colors.neutral[100]};

  ${breakpointsMQ4.sm.down} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const InfoStyled = styled.div`
  ${breakpointsMQ4.sm.down} {
    &:not(:last-child) {
      border-bottom: 0.1rem solid ${colors.neutral[200]};
      padding-bottom: 1.5rem;
    }
  }
`;

export const DependentBlockKeyStyled = styled.p`
  ${typography.capsBold[14]};
  color: ${colors.neutral[500]};
  margin: 0 0 1rem;
`;

export const DependentBlockValueStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
`;
